// @flow
import Spinner from 'components/Spinner'
import { useLoadStripeCustomer } from 'queries/payments/useLoadStripeCustomer'
import * as React from 'react'
import Flex from 'ui/atoms/Flex'
import FlexBox from 'ui/atoms/FlexBox'
import Table from 'ui/atoms/Table'
import Text from 'ui/atoms/Text'

import EditBillingDetails from './EditBillingDetails.jsx'

function BillingDetails(): React.Node {
  const { data, isLoading } = useLoadStripeCustomer()
  const [showUpdateBillingDetailsModal, setShowUpdateBillingDetailsModal] =
    React.useState(false)

  return (
    <>
      <FlexBox className="max-w-2xl">
        <Table.Title>
          <Flex align="center" className="w-full" justify="between">
            <Text>Billing Details</Text>
            <Text
              $active={!!data}
              $muted={!data}
              className="cursor-pointer"
              onClick={() => {
                if (!!data) {
                  setShowUpdateBillingDetailsModal(true)
                }
              }}
            >
              Edit Billing Details
            </Text>
          </Flex>
        </Table.Title>
        <Table>
          <Table.Body>
            <Table.Row>
              {isLoading ? (
                <Table.Column>
                  <Spinner color="onLight" />
                </Table.Column>
              ) : (
                <>
                  {data?.address ? (
                    <>
                      <Table.Column>
                        <Flex>
                          <Text>{data.address?.line1 || ''}</Text>
                        </Flex>
                        <Flex>
                          <Text>{data.address?.line2}</Text>
                        </Flex>
                        <Flex>
                          <Text>
                            {data.address?.city || ''},{' '}
                            {data.address?.state || ''}{' '}
                            {data.address?.postal_code || ''},{' '}
                            {data.address?.country || ''}
                          </Text>
                        </Flex>
                      </Table.Column>
                    </>
                  ) : (
                    <Table.Column>
                      <Flex align="center">
                        <Text>
                          You haven't added any billing information yet.
                        </Text>
                      </Flex>
                    </Table.Column>
                  )}
                </>
              )}
            </Table.Row>
          </Table.Body>
        </Table>
      </FlexBox>
      {showUpdateBillingDetailsModal && (
        <EditBillingDetails
          onClose={() => setShowUpdateBillingDetailsModal(false)}
        />
      )}
    </>
  )
}

export default BillingDetails
